import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'mg-delete-image-confirmation-dialog',
  templateUrl: './DeleteImageConfirmation.component.html',
  styleUrls: ['./DeleteImageConfirmation.component.scss'],
})
export class DeleteImageConfirmationComponent {
  constructor(public dialogRef: MatDialogRef<DeleteImageConfirmationComponent>) {}
}
